import { useFlags } from '../../../context/featureFlag';
import { trpc } from '../../../../trpc/react';
import { BlockPreview } from '../types';

type UseCrossBlockBowlingOverlayArgs = {
  block: Pick<BlockPreview, 'id' | 'blockType'>;
  dateRange: { start: string; end: string };
};

/**
 * Fetches cross-block bowling workouts that overlap the current block's
 * rostered athletes within `dateRange`. Gated by
 * `crossBlockBowlingOverlayFlag` AND `blockType === 'bowling'` so non-bowling
 * blocks and rollout-disabled orgs avoid the round-trip.
 */
export function useCrossBlockBowlingOverlay({
  block,
  dateRange,
}: UseCrossBlockBowlingOverlayArgs) {
  const { crossBlockBowlingOverlayFlag } = useFlags();
  const enabled = block.blockType === 'bowling' && crossBlockBowlingOverlayFlag;
  return trpc.block.getOverlappingWorkouts.useQuery(
    { blockId: block.id, dateRange },
    { enabled },
  );
}
